<template>
  <div class="economic-readiness-chart-container">
    <div v-if="isLoading" class="economic-readiness-loading">
      <Loading/>
    </div>
    <template v-else>
      <div v-if="!hasData" class="economic-readiness-empty-state">
        {{ title }} - {{ emptyStateMessage }}
      </div>
      <div v-else>
        <h3 class="chart-title">{{ title }}</h3>
        <slot></slot>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Loading from '@/components/Dashboard/ConceptMap/Loading.vue'

export default defineComponent({
  name: 'ChartContainer',
  components: {
    Loading
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    hasData: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    emptyStateMessage: {
      type: String,
      default: 'No data to display'
    }
  }
})
</script> 

<style scoped>
.chart-title {
    margin-bottom: 0.5rem;
}
</style>